geojson_loader_handler = {

    properties: {
        type:{
            '1':{
                color: '#ff6468'
            },
            '2':{
                color: '#ff6468'
            },
            '3':{
                color: '#ff6468'
            },
            '4':{
                color: '#00c2cf'
            },
            '5':{
                color: '#00c2cf'
            }
        },

        ped_gap:{
            '1':{
                color: '#aadb30'
            },
            '2':{
                color: '#ff6468'
            }
        },

        ped_type:{
            '2':{
                color: '#ff6468'
            },
            '3':{
                color: '#00c2cf'
            }
        }
    },

    onLoad: function(){

    },

    loadComments: function(type){
        $.each(mapData.features, function(index, value) {
            if (this instanceof L.Marker) {
                if (this.options.category == type){
                    mapData.pointsLayer.addLayer(this);
                }
            } else if (this instanceof L.Path) {
                if (this.options.category == type){
                    mapData.lineStringLayer.addLayer(this);
                }
            }
        });
    },

    removeData: function(){
        $.each(mapData.geoJSONData, function(index, value) {
            mapData.geoJSONLayer.removeLayer(mapData.geoJSONLayers[index]);
        });
    },

    fetch: function(opts) {
        var defaults = {
            label: "foo",
            url: "foo",
            source: "source",
            dataType: "line",
            preprocessJSONResponse: _.identity,
            style: {
                color: '#000',
                weight: 15,
                opacity: 1,
                className: "proposed",
            },
        };
        opts = $.extend(defaults, opts);

        var self = this;

        if (typeof mapData.geoJSONLayers[opts.label] !== 'undefined') {
            // If it exists we can just redispaly it rather than fetch.
            mapData.geoJSONLayer.addLayer(mapData.geoJSONLayers[opts.label]);
            return false;
        }

        if (opts.dataType === 'point') {
            mapData.geoJSONLayers[opts.label] = L.featureGroup();
            mapData.geoJSONLayers[opts.label].addTo(mapData.geoJSONLayer);
        } else {
            mapData.geoJSONLayers[opts.label] = L.featureGroup();
            mapData.geoJSONLayers[opts.label].addTo(mapData.geoJSONLayer);
        }

        if (typeof mapData.geoJSONList[opts.mapView] === 'undefined') {
          mapData.geoJSONList[opts.mapView] = [];
        }

        if (typeof mapData.geoJSONData[opts.label] === 'undefined') {
          mapData.geoJSONData[opts.label] = {};
        }

        $.ajax({
            url: opts.source,
            // beforeSend: function(){
            //     // TODO: fix spin
            //     // map.spin(true);
            // },
        }).done(function(r) {
          var resp = opts.preprocessJSONResponse(r);
          
          mapData.geoJSON[opts.label] = new L.geoJSON(resp, {
              clickable: true,
              style: opts.style || {
                  color: '#000',
                  weight: 15,
                  opacity: 1,
                  className: "proposed",
              },
              onEachFeature: function(f, l) {
                  var _id = f.properties.OBJECTID;
                  var parentID = l._leaflet_id || L.Util.stamp(l);
                  mapData.geoJSONList[opts.mapView].push({
                      typeID: opts.mapView,
                      subtypeID: opts.label,
                      id: parentID
                  });
  
                  var type = 1;
                  mapData.geoJSONData[opts.label][parentID] = l;

                  if (opts.dataType !== 'point') {
                     l.setStyle({
                         // color: '#000',
                         // features: f.properties
                         id: _id,
                         parentID: parentID,
                     });
                  }
  
                  // mapData.geoJSONData[opts.label][parentID].on('click', function(e) {
                  l.on('click', function(e) {
                      var uri =  "#/project-view/" + opts.url + '/' + opts.label + '/' + parentID;
                      window.location.hash = uri; 
                  });
  
                  // TODO: polyline rollover breaks click, maybe do with CSS
                  // instead.
                  //
                  // mapData.geoJSONData[opts.label][parentID].on('mouseover', function(e) {
                  //     var layer = e.target;
                  //     // TODO: marker rollover
                  //     if (opts.dataType === 'point' || layer.options.pane === 'markerPane') {
                  //       home_handler.rollOverMarker(layer);
                  //     } else {
                  //       home_handler.rollOverPolyline(layer);
                  //     }
                  // });
  
                  // mapData.geoJSONData[opts.label][parentID].on('mouseout', function(e) {
                  //     mapData.rollOverLayer.clearLayers();
                  // });
  
                  mapData.geoJSONData[opts.label][parentID].addTo(mapData.geoJSONLayers[opts.label]);
              }
          });
          mapData.geoJSON[opts.label].addTo(map);
          // map.spin(false);
        });

    },

    loadData: function(data){
        var self = this;
        // TODO: disabling this for now
        return false;

        //Load Bike Data
        // if (data == 'bike'){
        //     if (!mapData.geoJSON.bike){
        //         mapData.geoJSONLayers.bike = L.featureGroup();
        //         mapData.geoJSONLayers.bike.addTo(mapData.geoJSONLayer);

        //         $.get("data/ohc-projects.geojson?ver=9", function(resp) {
        //           mapData.geoJSON.bike = new L.geoJSON(resp, {
        //               clickable: true,
        //               onEachFeature: self.geoJSONPopUpBike,
        //               style: {
        //                   color: '#000',
        //                   weight: 30,
        //                   opacity: 0,
        //                   className: "proposed",
        //               }
        //           });
        //           mapData.geoJSON.bike.on('data:loading', function() {
        //               map.spin(true);
        //           }.bind(this));
        //           mapData.geoJSON.bike.on('data:loaded', function() {
        //             map.spin(false);
        //             geojson_loader_handler.loadData('ped-cross');
        //           }.bind(this));
        //         });

        //     }
        //     else {
        //         mapData.geoJSONLayers.bike.addTo(mapData.geoJSONLayer);
        //         geojson_loader_handler.loadData('ped-cross');

        //     }
        // }

        //Load Ped Gap Data
        // if (data == 'ped-gap'){
        //     if (!mapData.geoJSON.pedgap){
        //         mapData.geoJSONLayers.pedgap = L.featureGroup();
        //         mapData.geoJSONLayers.pedgap.addTo(mapData.geoJSONLayer);

        //         $.get("data/ped-network-all-green.geojson", function(resp) {
        //           mapData.geoJSON.pedgap = new L.geoJSON(resp, {
        //               clickable: false,
        //               onEachFeature: self.geoJSONPopUpPedGap,
        //               style: {
        //                   color: '#ff6468',
        //                   weight: 3,
        //                   opacity: 1,
        //                   className: "proposed",
        //               }
        //           });
        //           mapData.geoJSON.pedgap.on('data:loading', function() {
        //               map.spin(true);
        //           }.bind(this));
        //           mapData.geoJSON.pedgap.on('data:loaded', function() {
        //             map.spin(false);
        //           }.bind(this));

        //         });
        //     }
        //     else {
        //         mapData.geoJSONLayers.pedgap.addTo(mapData.geoJSONLayer);

        //     }

        //     geojson_loader_handler.loadData('ped-cross');
        // }

        //Load Transit Data
        // if (data == 'transit'){
        //     if (!mapData.geoJSON.transit){
        //         mapData.geoJSONLayers.transit = L.featureGroup();
        //         mapData.geoJSONLayers.transit.addTo(mapData.geoJSONLayer);

        //         mapData.geoJSON.transit = new L.GeoJSON.AJAX(["data/transit-network.geojson"],{
        //             clickable: true,
        //             onEachFeature: self.geoJSONPopUpTransit,
        //             style: {
        //                 color: '#039ead',
        //                 weight: 5,
        //                 opacity: 1,
        //                 className: "proposed",
        //             }
        //         });
        //         mapData.geoJSON.transit.on('data:loading', function() {
        //             map.spin(true);
        //         }.bind(this));
        //         mapData.geoJSON.transit.on('data:loaded', function() {
        //           map.spin(false);
        //         }.bind(this));
        //     }
        //     else {
        //         mapData.geoJSONLayers.transit.addTo(mapData.geoJSONLayer);
        //     }
        // }

    },

    geoJSONPopUpBike: function(f,l){
        var self = this;

        var id = f.properties.OBJECTID;
        var parentID = l['_leaflet_id'];
        mapData.geoJSONList.bike.push(parentID);

        var type = 1;
        mapData.geoJSONData.bike[parentID] = l;
        l.setStyle({
            color: '#000',
            id: id,
            parentID: parentID,
            features: f.properties
        });

        mapData.geoJSONData.bike[parentID].on('click', function(e) {
            window.location.href = "#/project-view/" + parentID + '/bike';
        });

        mapData.geoJSONData.bike[parentID].on('mouseover', function(e) {
            var layer = e.target;
            home_handler.rollOverPolyline(layer);
        });

        mapData.geoJSONData.bike[parentID].on('mouseout', function(e) {
            mapData.rollOverLayer.clearLayers();
        });

        mapData.geoJSONData.bike[parentID].addTo(mapData.geoJSONLayers.bike);

    },

    geoJSONPopUpPedGap: function(f,l){
        var self = this;
        var id = f.properties.OBJECTID;
        var type = f.properties.type;
        mapData.geoJSONData.pedgap[id] = l;
        l.setStyle({
            color: geojson_loader_handler.properties.ped_gap[type].color || '#ff6468',
            id: id,
            features: f.properties
        });
        mapData.geoJSONData.pedgap[id].addTo(mapData.geoJSONLayers.pedgap);

    },

    geoJSONPopUpPedCross: function(f,l){
        var self = this;
        var id = f.properties.OBJECTID;
        var type = 3;
        var properties = f.properties;

        mapData.geoJSONList.pedcross.push(id);

        var userLocation = new L.Circle(l.getLatLng(), 20, {
            fillColor: geojson_loader_handler.properties.ped_type[type].color || '#000',
            color: "#FFF",
            weight: 1,
            opacity: 1,
            fillOpacity: 0.7,
            className: "user-locations",
            clickable: true,
            properties: properties
        });

        mapData.geoJSONData.pedcross[id] = userLocation;

        mapData.geoJSONData.pedcross[id].on('click', function(e) {
            window.location.href = "#/project-view/" + id + '/pedcross';
        });

        mapData.geoJSONData.pedcross[id].addTo(mapData.geoJSONLayers.pedcross);

    },

    geoJSONPopUpTransit: function(f,l){
        var self = this;
        var id = f.properties.OBJECTID;
        mapData.geoJSONList.transit.push(id);
        mapData.geoJSONData.transit[id] = l;
        l.setStyle({
            id: id,
            features: f.properties
        });

        mapData.geoJSONData.transit[id].on('click', function(e) {
            window.location.href = "#/project-view/" + id + '/transit';
        });

        mapData.geoJSONData.transit[id].on('mouseover', function(e) {
            var layer = e.target;
            home_handler.rollOverPolyline(layer);
        });

        mapData.geoJSONData.transit[id].on('mouseout', function(e) {
            mapData.rollOverLayer.clearLayers();
        });

        mapData.geoJSONData.transit[id].addTo(mapData.geoJSONLayers.transit);

    },

    events: function() {
        var self = this;
        self.onLoad();
    }
}
